module.exports = "/build/web/svg/social/instagram.5d53efbffb51075c5b3b24ad69875348.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/instagram.svg
// module id = 190
// module chunks = 24